import React, { CSSProperties, FC, Fragment, ReactElement } from "react";
import FeatureBlockWrapper, {
  ButtonWrapper,
  ContentWrapper,
  IconWrapper
} from "./featureBlock.style";

interface FeatureBlockProps {
  className?: string;
  title?: ReactElement | string;
  description?: ReactElement | string;
  button?: ReactElement;
  iconPosition?: "top" | "left" | "right";
  wrapperStyle?: CSSProperties;
  iconStyle?: CSSProperties;
  contentStyle?: CSSProperties;
  btnWrapperStyle?: CSSProperties;
  icon?: ReactElement;
  additionalContent?: any;
}

const FeatureBlock: FC<FeatureBlockProps> = ({
  className,
  icon,
  title,
  button,
  description,
  iconPosition,
  additionalContent,
  wrapperStyle,
  iconStyle,
  contentStyle,
  btnWrapperStyle,
  ...props
}) => {
  // Add all classs to an array
  const addAllClasses = ["feature__block"];

  // Add icon position class
  if (iconPosition) {
    addAllClasses.push(`icon_${iconPosition}`);
  }

  // className prop checking
  if (className) {
    addAllClasses.push(className);
  }

  // check icon value and add
  const Icon = icon && (
    <IconWrapper className="icon__wrapper" {...iconStyle}>
      {icon}
    </IconWrapper>
  );

  return (
    <FeatureBlockWrapper
      className={addAllClasses.join(" ")}
      {...wrapperStyle}
      {...props}
    >
      {Icon}

      {title || description || button ? (
        <Fragment>
          <ContentWrapper className="content__wrapper" {...contentStyle}>
            {title}
            {description}
            {button && (
              <ButtonWrapper className="button__wrapper" {...btnWrapperStyle}>
                {button}
              </ButtonWrapper>
            )}
          </ContentWrapper>
          {additionalContent}
        </Fragment>
      ) : (
        ""
      )}
    </FeatureBlockWrapper>
  );
};

FeatureBlock.defaultProps = {
  iconPosition: "top"
};

export default FeatureBlock;
